import React, { Component, createElement, Fragment } from 'react';
import { Modal as AntModal, Icon } from 'antd';
import { ComponentsManager } from '@comall-backend-builder/core';
import { extendsParentProps } from '@comall-backend-builder/components-basis';
import Password from './password';

export class ModifyPwdModalForm extends Component<any, any> {
    state: any = {
        visible: false,
    };

    /**
     * 通过点击事件来触发弹层
     */
    handleTriggerClick = () => {
        this.setState({ visible: true });
    };

    /**
     * 关闭弹窗
     */
    handleCancelClick = () => {
        this.setState({ visible: false });
    }

    /**
     * 渲染响应触发弹层事件的组件
     */
    renderTrigger() {
        let { text } = this.props.triggerComponent;
        return (
            <div onClick={this.handleTriggerClick}>
                <Icon type="edit"></Icon>
                <span>{text}</span>
            </div>
        );
    }
    /**
     * 渲染组件的方法
     */
    renderComponent(componentProps: any) {
        let { component, ...otherProps } = componentProps;
        let props = extendsParentProps({ ...otherProps }, this.props);
        return createElement(ComponentsManager.get(component), props);
    }

    render() {
        const {
            title,
            mask = true,
            maskClosable = false,
            width,
            className,
            style,
            zIndex,
        } = this.props;
        const modalProps = {
            title,
            mask,
            maskClosable,
            width,
            wrapClassName: className,
            style,
            zIndex,
            visible: this.state.visible,
            footer: null,
            onCancel: this.handleCancelClick,
        };
        return (
            <Fragment>
                {this.renderTrigger()}
                <AntModal {...modalProps}>
                    {this.state.visible ? (
                        <Password click={this.handleCancelClick} />
                    ) : null}
                </AntModal>
            </Fragment>
        );
    }
}